<DataGridView DataUrl="/Backend/Api/V2/Admin/Geraete/List" #Grid KeyProperty="key" [CustomiseRowCssClass]="DeaktivatedDevice" >
  <DataGridViewColumn field="geraeteInfo.deviceID" header="Geräte-ID" />
  <DataGridViewColumn field="geraeteInfo.clipID" header="Clip-ID" />
  <DataGridViewColumn field="geraeteInfo.seriennummer" header="Seriennummer" />
  <DataGridViewColumn field="partner.stammdaten.name" header="K-Partner" />
  <DataGridViewColumn field="leitsetlle.name" header="Keitsetlle" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Gerät">
        <ng-template #staticContent>
          <GeraeteEdit [Key]="row?.key"></GeraeteEdit>
        </ng-template>
      </PopUpView>
      <i class="btn btn-sm ms-1 btn-danger bi bi-trash3-fill" *IsAdmin (click)="Delete(row?.key)"></i>
    </ng-template>
    <ng-template #header >
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Gerät">
        <ng-template #staticContent>
          <GeraeteEdit></GeraeteEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
<floatingButton icon="bi bi-cloud-arrow-up-fill" titel="Import Geräteliste" color="rgb(0 127 184)" (btnClick)="UploadData()"></floatingButton>
<ng-template #successTpl> Upload erfolgreich! </ng-template>
<ng-template #successDelTpl> Löschen erfolgreich! </ng-template>
<ng-template #FailDelTpl> Löschen nicht möglich! </ng-template>
